import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class TemperatureReadings_ds_shipment_lines_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shipmentId?: number, fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, LineNumber?: number, ShipmentId?: number, OrderLine?: { LineNumber?: number, Material?: { LookupCode?: string }, Order?: { LookupCode?: string } }, Shipment?: { LookupCode?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/TemperatureReadings/datasources/ds_shipment_lines_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shipmentId?: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LineNumber?: number, ShipmentId?: number, OrderLine?: { LineNumber?: number, Material?: { LookupCode?: string }, Order?: { LookupCode?: string } }, Shipment?: { LookupCode?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/TemperatureReadings/datasources/ds_shipment_lines_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shipmentId?: number, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LineNumber?: number, ShipmentId?: number, OrderLine?: { LineNumber?: number, Material?: { LookupCode?: string }, Order?: { LookupCode?: string } }, Shipment?: { LookupCode?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/TemperatureReadings/datasources/ds_shipment_lines_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shipmentId?: number, fullTextSearch?: string    }) {
      return false;
    }
}
